import { isEqual } from 'lodash'

// MUI Select matches object values by reference. A value that is deep-equal to an option's
// value but not the same object (e.g. a record loaded from the API) is out-of-range, so swap
// it for the matching option's own value.
export const matchOptionValue = (value, options) => {
  // a stored plain value ("Owner", as a relation field's option is saved) selects the option whose own value it is; lists here build
  // their options as `{ ...o, value: o }`, so that option's `value` is the whole option object
  if (typeof value === 'string' && Array.isArray(options) && !options.some(o => o?.value === value)) {
    // an option with no value of its own is saved by its name (relationItems.js relationPayloadValue), so a name selects it too
    const nested = options.find(o => o?.constructor === Object && o.value && typeof o.value === 'object' && (o.value.value === value || (!o.value.value && o.value.name === value)))
    if (nested) return nested.value
  }
  if (!value || typeof value !== 'object' || !Array.isArray(options)) return value
  const match = options.find(o => o?.constructor === Object && o.value !== undefined && (o.value === value || isEqual(o.value, value) || isEqual(o, value)))
  return match ? match.value : value
}
